export default __webpack_public_path__ + "static/media/juego rio 2-31.b5d42cbb.png";